import { format } from 'date-fns';

const getTimestampText = (ts: string, showFullYear?: boolean) =>
  format(new Date(ts), showFullYear ? 'M/d/yyyy, hh:mm a' : 'M/d/yy, hh:mm a');

export default getTimestampText;
